import { render, staticRenderFns } from "./LolitaData.vue?vue&type=template&id=35c3f797&scoped=true&"
import script from "./LolitaData.vue?vue&type=script&lang=js&"
export * from "./LolitaData.vue?vue&type=script&lang=js&"
import style0 from "./LolitaData.vue?vue&type=style&index=0&id=35c3f797&prod&lang=css&"
import style1 from "./LolitaData.vue?vue&type=style&index=1&id=35c3f797&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3f797",
  null
  
)

export default component.exports